const dateFormattingOptions = {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
};
export const formatDate = (date: string) => {
  if (date === null || date === undefined) {
    return undefined;
  }
  return new Date(date).toLocaleDateString(
    'en-US',
    dateFormattingOptions as Intl.DateTimeFormatOptions
  );
};

export const formatDateRange = (startDate: string, endDate: string) => {
  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  };
};
